// CheckoutMaster — Shopify Theme Snippet
// Inject in layout/theme.liquid before </body> or upload as assets/custom-checkout.js
// Config: window.__CUSTOM_CHECKOUT__ = { api: "https://checkout.{domain}", tenant: "{slug}" }
(function() {
  'use strict';

  var CFG = window.__CUSTOM_CHECKOUT__ || {};
  if (!CFG.api || !CFG.tenant) return;

  // === 1. CHECKOUT BUTTON SELECTORS (30+ battle-tested) ===
  var SELECTORS = [
    'button[name="checkout"]', 'button[name="Checkout"]', 'button#checkout',
    '#CartDrawer-Checkout', '.cart__checkout-button', '.cart__checkout',
    '.checkout-button', '.checkout-btn', '.btn-checkout', '.button-checkout',
    'a[href$="/checkout"]', 'a[href^="/checkout"]', 'a[href*="/checkout?"]',
    'form[action="/cart"] [name="checkout"]', 'form[action^="/cart"] [name="checkout"]',
    '.m-cart-drawer__checkout-btn',
    '[data-lasso-checkout]', '[class*="upcart-checkout"]',
    '[class*="opus-btn-checkout"]', '[class*="slide-cart-checkout"]',
    '[class*="carthook_checkout"]', '[class*="checkout-btn"]',
    '[class*="btn-checkout"]', '[class*="checkout-button"]',
    '[id*="checkout"]:not([id*="express"])', '[id*="Checkout"]',
    '[onclick*="/checkout"]', '[class*="proceed-custom"]'
  ];

  var inFlight = false;
  var currentSessionId = localStorage.getItem('__cm_sid') || null;

  // === 2. UTM CAPTURE (13+ params to localStorage) ===
  var UTM_PARAMS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'ScCid', 'epik'
  ];
  (function captureUTM() {
    var params = new URLSearchParams(window.location.search);
    UTM_PARAMS.forEach(function(k) {
      var v = params.get(k);
      if (v) localStorage.setItem('__cm_' + k, v);
    });
  })();

  function getUTM() {
    var utm = {};
    UTM_PARAMS.forEach(function(k) {
      var v = localStorage.getItem('__cm_' + k);
      if (v) utm[k] = v;
    });
    utm.fbp = getCookie('_fbp');
    utm.fbc = getCookie('_fbc');
    return utm;
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  // === 3. CURRENCY DETECTION ===
  function detectCurrency() {
    try {
      if (window.hextom_currency) return String(window.hextom_currency).toUpperCase();
      var hc = document.cookie.match(/hextom_currency=([A-Z]{3})/);
      if (hc) return hc[1];
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) return window.Shopify.currency.active;
    } catch(_) {}
    return null;
  }

  // === 4. CART SYNC (real-time on every cart change) ===
  function mapCartItems(cart) {
    return (cart.items || []).map(function(item) {
      return {
        variantId: 'gid://shopify/ProductVariant/' + item.variant_id,
        productId: 'gid://shopify/Product/' + item.product_id,
        title: item.product_title,
        variantTitle: item.variant_title || null,
        image: item.image || null,
        price: item.original_price || item.price,
        finalPrice: item.final_price,
        finalLinePrice: item.final_line_price,
        originalLinePrice: item.original_line_price,
        quantity: item.quantity,
        discounts: (item.discounts || []).map(function(d) { return { title: d.title, amount: d.amount }; }),
        properties: item.properties || {}
      };
    });
  }

  var syncTimeout = null;
  function debouncedSync(cart) {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(function() { syncCart(cart); }, 300);
  }

  function syncCart(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return;
    var payload = {
      tenantId: CFG.tenant,
      items: mapCartItems(cart),
      currency: detectCurrency() || (cart.currency || null),
      sessionId: currentSessionId,
      cartDiscounts: (cart.cart_level_discount_applications || []).map(function(d) {
        return { title: d.title, amount: d.total_allocated_amount };
      })
    };
    fetch(CFG.api + '/api/cart-sessions/sync', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify(payload)
    }).then(function(r) { return r.json(); }).then(function(data) {
      if (data.sessionId) {
        currentSessionId = data.sessionId;
        localStorage.setItem('__cm_sid', data.sessionId);
      }
    }).catch(function(err) { console.warn('[CM] sync error:', err); });
  }

  // === 5. FETCH/XHR PATCHING ===
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url || '');
    var isCartUrl = /\/cart(\.js|\/add(\.js)?|\/change\.js|\/update\.js|\/clear\.js)?(\?|$)/.test(url);
    var isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var resp = origFetch.apply(this, arguments);

    if (isCartUrl && url.indexOf(CFG.api) === -1) {
      resp.then(function(r) {
        try {
          var clone = r.clone();
          if (isCartAdd) {
            fetch('/cart.js').then(function(r2) { return r2.json(); }).then(debouncedSync).catch(function(){});
          } else {
            clone.json().then(debouncedSync).catch(function(){});
          }
        } catch(_) {}
        return r;
      });
    }
    return resp;
  };

  var origXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._cmIsCart = /\/cart(\.js|\/)/i.test(url) && url.indexOf(CFG.api) === -1;
    return origXhrOpen.apply(this, arguments);
  };
  var origXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    if (this._cmIsCart) {
      this.addEventListener('load', function() {
        try { var d = JSON.parse(this.responseText); if (d) debouncedSync(d); } catch(_) {}
      });
    }
    return origXhrSend.apply(this, arguments);
  };

  // === 6. SESSION RECOVERY (clear cart if session completed) ===
  (function checkSessionRecovery() {
    var sid = localStorage.getItem('__cm_sid');
    if (!sid) return;
    fetch(CFG.api + '/api/checkout/sessions/' + sid, { credentials: 'omit' })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (data && data.session && data.session.status === 'completed') {
          localStorage.removeItem('__cm_sid');
          currentSessionId = null;
          fetch('/cart/clear.js', { method: 'POST' }).catch(function(){});
        }
      }).catch(function(){});
  })();

  // === 7. CHECKOUT REDIRECT ===
  window.__cmProceedToCheckout = async function() {
    if (inFlight) return;
    inFlight = true;

    try {
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
      if (!cart.items || cart.items.length === 0) { inFlight = false; return; }

      var payload = {
        tenantId: CFG.tenant,
        sessionId: currentSessionId,
        items: mapCartItems(cart),
        cartDiscounts: (cart.cart_level_discount_applications || []).map(function(d) {
          return { title: d.title, amount: d.total_allocated_amount };
        }),
        clientCurrency: detectCurrency(),
        utm: getUTM(),
        referrer: document.referrer || null
      };

      var res = await fetch(CFG.api + '/api/checkout/sessions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify(payload)
      }).then(function(r) { return r.json(); });

      if (res.checkoutUrl) {
        var utm = getUTM();
        var qs = [];
        Object.keys(utm).forEach(function(k) {
          if (utm[k]) qs.push(encodeURIComponent(k) + '=' + encodeURIComponent(utm[k]));
        });
        var sep = res.checkoutUrl.indexOf('?') === -1 ? '?' : '&';
        var url = qs.length ? res.checkoutUrl + sep + qs.join('&') : res.checkoutUrl;
        window.location.href = url;
      } else {
        throw new Error(res.error || 'no checkoutUrl');
      }
    } catch(err) {
      console.error('[CM] checkout error:', err);
      inFlight = false;
    }
  };

  // === 8. BIND CHECKOUT BUTTONS ===
  function bindButtons(root) {
    root = root || document;
    root.querySelectorAll(SELECTORS.join(',')).forEach(function(btn) {
      if (btn.__cmBound) return;
      btn.__cmBound = true;
      var handler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.__cmProceedToCheckout();
      };
      btn.addEventListener('click', handler, { capture: true });
      btn.addEventListener('mousedown', handler, { capture: true });
      btn.addEventListener('touchstart', handler, { capture: true });
    });

    root.querySelectorAll('form[action^="/cart"], form[action="/checkout"]').forEach(function(form) {
      if (form.__cmBound || (form.getAttribute('action') || '').includes('/cart/add')) return;
      form.__cmBound = true;
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.__cmProceedToCheckout();
      }, { capture: true });
    });
  }

  bindButtons();
  new MutationObserver(function() { bindButtons(); }).observe(document.body, { childList: true, subtree: true });

  // === 9. BFCACHE RESET ===
  window.addEventListener('pageshow', function(e) { if (e.persisted) inFlight = false; });

})();
